/* Дарааллын карт — дизайны queue-board.jsx-ээс */
import { CAR_TYPES } from '../shared/data';
import { carTotal, tug } from '../shared/format';
import { IconCar, IconX } from '../shared/icons';
import type { QueueCar } from '../shared/types';
import { ActionButton, ElapsedChip, Plate, QueuePosBadge, WasherChip } from './bits';

export interface QueueCardProps {
  car: QueueCar;
  now: number;
  onAdvance: (car: QueueCar) => void;
  onCancel: (car: QueueCar) => void;
  big?: boolean;
  queuePos?: number | null;
  currentWasher?: string;
}

export function QueueCard({ car, now, onAdvance, onCancel, big, queuePos, currentWasher }: QueueCardProps) {
  const TypeIcon = CAR_TYPES[car.type] || IconCar;
  return (
    <div className={
      'bg-white rounded-[var(--r)] shadow-xs ring-1 ring-slate-900/5 flex flex-col ' +
      (big ? 'p-3.5 gap-2.5' : 'p-2.5 gap-2') +
      (car.status === 'done' ? ' ring-emerald-500/25' : '')
    }>
      <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
        <Plate plate={car.plate} size={big ? 'lg' : 'md'} />
        {queuePos != null && <QueuePosBadge pos={queuePos} />}
        <ElapsedChip car={car} now={now} className="ml-auto" />
      </div>

      <div className="flex items-center gap-1.5 text-[12px] text-slate-600 min-w-0">
        <TypeIcon size={14} strokeWidth={2} className="text-slate-400" />
        <span className="font-medium text-slate-700 shrink-0">{car.type}</span>
        <span className="text-slate-300">·</span>
        <span className="truncate" title={car.services.join(', ')}>{car.services.join(', ')}</span>
      </div>

      <div className="flex items-center gap-1.5 min-w-0 flex-wrap">
        {car.washers.map((w) => (
          <WasherChip key={w.id} name={w.name}
            highlight={!!currentWasher && w.name === currentWasher && big} big={big} />
        ))}
        <span className="ml-auto text-[13px] font-bold text-slate-900 whitespace-nowrap">{tug(carTotal(car))}</span>
      </div>

      <div className="flex gap-1.5">
        <ActionButton car={car} onAdvance={onAdvance} big={big} />
        {car.status !== 'done' && (
          <button onClick={() => onCancel(car)} title="Цуцлах"
            className={
              'shrink-0 inline-flex items-center justify-center rounded-[calc(var(--r)-5px)] text-slate-400 bg-slate-50 ring-1 ring-slate-200 hover:bg-rose-50 hover:text-rose-600 hover:ring-rose-200 transition active:scale-[0.96] ' +
              (big ? 'w-12 min-h-[48px]' : 'w-9 h-9')
            }>
            <IconX size={big ? 18 : 15} strokeWidth={2.2} />
          </button>
        )}
      </div>
    </div>
  );
}
